export default __webpack_public_path__ + "static/media/crown.0187391f.png";